module.exports = __webpack_public_path__ + "sx.c70e8d70.svg";